import { env } from '@/constants/env';
import { useUserStore } from '@/piniaStores/user/user.store';

export function initZendeskChat() {
  if (env.VITE_ZENDESK_ENABLED !== 'true') {
    return;
  }

  const userStore = useUserStore();

  if (!userStore.user.zendeskChatJwt) {
    return;
  }

  if (!window.zESettings) {
    window.zESettings = {
      authenticate: {
        jwtFn: function (callback) {
          if (typeof userStore.user.zendeskChatJwt === 'string') {
            callback(userStore.user.zendeskChatJwt);
          }
        },
      },
    };
  }

  // source: https://support.zendesk.com/hc/en-us/articles/4408821673242-Adding-Web-Widget-Classic-to-your-website-or-help-center#topic_kf2_xcj_vz
  if (!window.zEmbed) {
    const e = '//assets.zendesk.com/embeddable_framework/main.js';
    const t = 'leaflinkhelp.zendesk.com';
    const a = [];
    const r = document.createElement('iframe');

    let n;
    let o;
    let d;

    window.zEmbed = function (...args) {
      // @ts-expect-error Argument of type 'unknown[]' is not assignable to parameter of type 'never'
      a.push(args);
    };
    window.zE = window.zE || window.zEmbed;
    r.src = 'javascript:false';
    r.title = '';
    r.role = 'presentation';
    // @ts-expect-error "frameElement" does not exist on type "HTMLIFrameElement"
    (r.frameElement || r).style.cssText = 'display: none';
    d = document.getElementsByTagName('script');
    d = d[d.length - 1];

    if (d?.parentNode) {
      d.parentNode.insertBefore(r, d);
    } else {
      document.body.appendChild(r);
    }

    const i = r.contentWindow;
    const s = i?.document;

    try {
      o = s;
    } catch (e) {
      n = document.domain;
      r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);';
      o = s;
    }

    o.open()._l = function () {
      const o = this.createElement('script');
      (n && (this.domain = n),
        (o.id = 'js-iframe-async'),
        (o.src = e),
        (this.t = +new Date()),
        (this.zendeskHost = t),
        (this.zEQueue = a),
        this.body.appendChild(o));
    };

    o.write('<body onload="document._l();">');
    o.close();
  }
}
